module.exports = __webpack_public_path__ + "img/IMG_3539_L_BlackMatted.c6a06aac.jpg";